import { getTranslation } from '../lang/main';
import { capitalize, getMemberType } from './converterSelector';
import { zeroPad } from '../_utils';
import { getNLISCustomLayers, getTagData, getTagDataForEditor } from './defaultSelectors';
import { changeFontColour, exportSVGs, getExportedJSONData as getEditorExportedJSONData, setTagData } from '../actions/editorActions';
import { resetCanvases, setupCanvases } from '../actions/canvasActions';
import { buildValidateNAITSequenceParams, getTagWizardExportedJSONData } from '../actions/tagWizardActions';

export const getRelatedProducts = (state) => {
    let list = [];
    const { relatedProductList } = state;
    const selectedProduct = getSelectedProduct(state);
    const selectedRelatedProducts = (selectedProduct && Object.values(selectedProduct.RelatedProducts)) || [];

    if (selectedRelatedProducts.length > 0) {
        selectedRelatedProducts.forEach((selectedRelatedProduct) => {
            const { ID, Order } = selectedRelatedProduct;
            if (typeof relatedProductList[ID] != 'undefined' && relatedProductList[ID]) {
                list.push({
                    ...relatedProductList[ID],
                    RelatedOrder: Order,
                });
            }
        });

        list.sort((a, b) => a.RelatedOrder - b.RelatedOrder);
    }

    return list;
};

export const getRelatedTags = (state) => {
    let list = [];
    const { relatedTags } = state;
    const selectedProduct = getSelectedProduct(state);

    if (
        typeof selectedProduct.RelatedTags != 'undefined' &&
        selectedProduct.RelatedTags &&
        selectedProduct.RelatedTags.length
    ) {
        selectedProduct.RelatedTags.forEach((id) => {
            if (typeof relatedTags[id] != 'undefined' && relatedTags[id]) {
                list.push(relatedTags[id]);
            }
        });
    }

    return list;
};
export const getAvailableMaleButtonsForSelectedProduct = (state) => {
    let list = {};
    const { maleButtonTags } = state;
    const selectedProduct = getSelectedProduct(state);

    // LEGIT
    if (selectedProduct && typeof (selectedProduct.MaleButtons) != 'undefined' && selectedProduct.MaleButtons.length > 0) {
        selectedProduct.MaleButtons.forEach(ID => {
            if (typeof (maleButtonTags[ID]) != 'undefined') {
                list[ID] = maleButtonTags[ID];
            }
        });
    }

    return list;
};
export const getSelectedMaleButtonProducts = (state) => {
    let list = [];
    const { selectedMaleButtons, userInput } = state;
    const { cartQty = 0 } = userInput;
    const availableMaleButtons = getAvailableMaleButtonsForSelectedProduct(state);

    Object.entries(selectedMaleButtons).forEach(([id, status]) => {
        if (status === true && typeof (availableMaleButtons[id]) != 'undefined') {
            list.push({
                ...availableMaleButtons[id],
                quantity: cartQty,
            });
        }
    });

    return list;
};
export const getSelectedIncludedItemsPayloadForNAIT = (state) => {
    let list = [];
    const { userInput, selectedIncludedItem } = state;
    const { cartQty, tagType } = userInput;

    const selectedProduct = getSelectedProduct(state);

    if (!selectedProduct) {
        return list;
    }

    const { ButtonRequired, OfficialType } = selectedProduct;

    if (tagType == 'nlis') {
        if (OfficialType === 'NAIT') {
            if (ButtonRequired == 2) {
                list.push({
                    ...selectedIncludedItem,
                    SalePrice: 0, // Because the price has been included
                    quantity: cartQty,
                });
            }
        }
    }

    return list;
};
export const getIncludedItems = (store) => {
    let list = [];
    const tagWizardState = store.tagWizard.present;
    const { userInput, currentScreen, selectedIncludedItem, products } = tagWizardState;
    const { cartQty, tagType, IncludeMMT } = userInput;

    const selectedMaleButtonProducts = getSelectedMaleButtonProducts(tagWizardState);
    const selectedProduct = getSelectedProduct(tagWizardState);
    const relatedTags = getRelatedTags(tagWizardState);
    // const selectedAddOns = Object.entries(state.selectedAddOns);

    if (!selectedProduct) {
        return list;
    }

    const { ButtonRequired, OfficialType } = selectedProduct;

    // The Product
    list.push({
        ...selectedProduct,
        quantity: cartQty,
    });

    // Additional product for Custom & NLIS
    if (tagType == 'editor' && currentScreen == 'ReviewScreen') {
        const additionalProductsForCustomTag = getAdditionalProductsForCustomTag(store);
        list = [...list, ...additionalProductsForCustomTag];
    } else if (tagType == 'nlis') {
        if (currentScreen == 'ReviewScreen') {
            const additionalProductsForNLIS = getAdditionalLineItemProductsForOfficialTag(store);
            list = [...list, ...additionalProductsForNLIS];
        }

        if (ButtonRequired == 2) {
            if (OfficialType === 'NAIT') {
                if (selectedIncludedItem) {
                    list.push({
                        ...selectedIncludedItem,
                        SalePrice: 0, // Because the price has been included
                        quantity: cartQty,
                    });
                }
            } else if (relatedTags.length > 0) {
                // first related tag
                list.push({
                    ...relatedTags[0],
                    SalePrice: 0, // Because the price has been included
                    quantity: cartQty,
                });
            }
        }
        if (ButtonRequired == 3) {
            // first & second related tag
            if (relatedTags.length > 0) {
                list.push({
                    ...relatedTags[0],
                    SalePrice: 0, // Because the price has been included
                    quantity: cartQty,
                });
            }
            if (relatedTags.length > 1) {
                list.push({
                    ...relatedTags[1],
                    SalePrice: 0, // Because the price has been included
                    quantity: cartQty,
                });
            }
        }

        // Add matching management tags
        if (IncludeMMT == 1) {
            const selectedMMTF = getSelectedMMTF(tagWizardState);
            if (selectedMMTF) {
                list.push({
                    ...selectedMMTF,
                    quantity: cartQty,
                    IsMMT: true,
                });

                const { IncludedProducts = [] } = selectedMMTF;
                if (IncludedProducts && IncludedProducts.length) {
                    IncludedProducts.forEach(item => {
                        const includedProduct = products[item.ID] || false;

                        if (includedProduct) {
                            list.push({
                                ...includedProduct,
                                quantity: cartQty,
                            });
                        }
                    });
                }
            }

            const selectedMMT = getSelectedMMT(tagWizardState);
            if (selectedMMT) {
                list.push({
                    ...selectedMMT,
                    quantity: cartQty,
                    IsMMT: true,
                });

                const { IncludedProducts = [] } = selectedMMTF;
                if (IncludedProducts && IncludedProducts.length) {
                    IncludedProducts.forEach(item => {
                        const includedProduct = products[item.ID] || false;

                        if (includedProduct) {
                            list.push({
                                ...includedProduct,
                                quantity: cartQty,
                            });
                        }
                    });
                }
            }
        }
    }

    // Male Button Products
    if (selectedMaleButtonProducts.length) {
        list = [...list, ...selectedMaleButtonProducts];
    }

    // if (relatedTags.length) {
    //     list = [...list, ...relatedTags];
    // }

    return list;
};

export const getFinalPrice = (productList) => {
    let total = 0;

    if (productList && productList.length) {
        productList.forEach((item) => {
            if (typeof item.SalePrice != 'undefined') {
                const { SalePrice, quantity } = item;
                total += Number(SalePrice) * quantity;
            }
        });
    }

    return total;
};
export const getSelectedProduct = (state) => {
    const { selectedProduct, products } = state;

    if (selectedProduct) {
        if (typeof products[selectedProduct] != 'undefined') {
            return products[selectedProduct];
        }
    }

    return false;
};
export const getSelectedMMT = (state) => {
    const { selectedMMT, matchingManagementTags } = state;

    if (selectedMMT) {
        if (typeof matchingManagementTags[selectedMMT] != 'undefined') {
            return matchingManagementTags[selectedMMT];
        }
    }

    return false;
};
export const getSelectedMMTF = (state) => {
    const { selectedMMTF, matchingManagementTags } = state;

    if (selectedMMTF) {
        if (typeof matchingManagementTags[selectedMMTF] != 'undefined') {
            return matchingManagementTags[selectedMMTF];
        }
    }

    return false;
};
export const getSelectedIncludedItem = (state) => {
    const { selectedMMTF, matchingManagementTags } = state;

    if (selectedMMTF) {
        if (typeof matchingManagementTags[selectedMMTF] != 'undefined') {
            return matchingManagementTags[selectedMMTF];
        }
    }

    return false;
};

export const checkAllowNLIS = (state) => {
    const { products } = state;

    return Object.values(products).some((product) => product.IsNLIS == true);
};

export const getAvailableTagUsage = (presentTagWizardState, store) => {
    const selectedProduct = getSelectedProduct(presentTagWizardState);
    const { orderOnBehalf } = store.user;

    const { IsNLIS, CustomTag, BlankTag } = selectedProduct;

    return {
        IsNLIS: (getMemberType(store) === 'wholesaler' && orderOnBehalf === false) ? false : IsNLIS,
        CustomTag,
        BlankTag,
    };
};

export const buildColourDropdown = (productList, tagType = '') => {
    let list = [];

    productList.forEach((product) => {
        if (
            ((tagType == 'nlis' && product.IsNLIS) ||
                tagType == 'editor' ||
                tagType == 'blank' ||
                tagType == 'mmt') &&
            product.ColourCode
        ) {
            list.push({
                label:
                    tagType == 'nlis'
                        ? product.OfficialColourName
                        : product.TagColour,
                value: product.ID,
                color: product.ColourCode || '#ffcc00',
                order: product.order,
                sku: product.InternalItemID,
            });
        }
    });

    // // Sort by order
    // list = list.sort((a, b) => {
    //     return a.order - b.order;
    // });

    // Sort by SKU
    if (list.length > 0) {
        const collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' })
        list = list.sort((a, b) => collator.compare(a.sku, b.sku));
    }

    return list;
};

export const buildItemIncludedColourDropdown = (productList) => {
    let list = [];

    productList.forEach((product) => {
        list.push({
            label: product.TagColour,
            value: product.ID,
            color: product.ColourCode || '#ffcc00',
            order: product.order,
            sku: product.InternalItemID,
        });
    });


    // Sort by SKU
    if (list.length > 0) {
        const collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' })
        list = list.sort((a, b) => collator.compare(a.sku, b.sku));
    }

    return list;
};

export const getAvailableColours = (state) => {
    const { products, userInput } = state;

    let list = [];

    if (userInput) {
        const { tagType } = userInput;

        list = buildColourDropdown(Object.values(products), tagType);
    }

    return list;
};

export const getAvailableItemIncludedColours = (state) => {
    const { relatedTags, userInput } = state;

    let list = [];

    if (userInput) {
        const { tagType } = userInput;

        list = buildItemIncludedColourDropdown(Object.values(relatedTags));
    }


    return list;
};

export const getAvailableItemIncludedNAITColours = (state) => {
    const { includedItems, userInput } = state;

    let list = [];

    if (userInput) {
        const { tagType } = userInput;

        list = buildItemIncludedColourDropdown(Object.values(includedItems));
    }


    return list;
};


export const getAvailablePrintingMethods = (state) => {
    let list = [];
    const selectedProduct = getSelectedProduct(state);

    if (selectedProduct.MarkingLines > 0) {
        list.push({
            label: 'Laser',
            value: 'Laser',
        });
    }

    if (selectedProduct.FoilStamping == 1) {
        list.push({
            label: 'Foil',
            value: 'Foil',
        });
    }

    return list;
};
export const getAvailableTagProductionTypes = (state) => {
    let list = [];
    const selectedProduct = getSelectedProduct(state);
    const { OfficialType, IsCattle = false } = selectedProduct;
    const { tagType } = state.userInput;

    if (OfficialType === 'NAIT' && tagType === 'nlis' && IsCattle === true) {
        list.push({
            label: 'Beef',
            value: 'Beef',
        });
        list.push({
            label: 'Dairy',
            value: 'Dairy',
        });
    }

    return list;
};
export const showIncludedItemsDropdown = (state) => {
    const selectedProduct = getSelectedProduct(state);

    if (selectedProduct?.IsDeer) {
        return true;
    }

    return false;
};
export const getAvailableDiseaseCode = (state) => {
    return [
        {
            label: getTranslation('FIELD.SELECT_DISEASE_CODE_NONE'),
            value: '',
        },
        {
            label: 'V - OJD Vaccine',
            value: 'V - OJD Vaccine',
        },
        {
            label: 'S - Scabby Mouth',
            value: 'S - Scabby Mouth',
        },
        {
            label: 'T - Terminal',
            value: 'T - Terminal',
        },
        {
            label: 'VS - OJD + Scabby Mouth',
            value: 'VS - OJD + Scabby Mouth',
        },
        {
            label: 'VT - OJD + Terminal',
            value: 'VT - OJD + Terminal',
        },
    ];
};

export const getAvailablePrefixCode = () => {
    return [...'ABCDEFGHJKLMNPQRSTUVWXYZ'].map((x) => ({
        label: x,
        value: x,
    }));
};

/**
 * Get the final disallowed NLIS states
 *
 * @param state
 * @returns array
 */
export const getDisallowedNLISStates = (state) => {
    const { disallowedNLISStates } = state;
    const selectedProduct = getSelectedProduct(state);

    let data = [...disallowedNLISStates];

    if (!selectedProduct) return data;

    const { AllowVic } = selectedProduct;
    const userAllowVicNLIS = window.allowVicNLIS || false;

    if (userAllowVicNLIS === true || AllowVic === true) {
        data = data.reduce((arr, state) => {
            if (state.toUpperCase() !== 'VIC') {
                arr.push(state);
            }

            return arr;
        }, []);
    }

    return data;
};

/**
 * Get available processed layouts
 *
 * @param state
 * @returns {Array}
 */
export const getAvailableProcessedLayouts = (state) => {
    const { availableProcessedLayouts } = state;
    const selectedProduct = getSelectedProduct(state);
    const codeTagFamily = selectedProduct.CodeTagFamily || '';
    const type = state.userInput.tagType || '';
    const diseaseCode = state.userInput.DiseaseCode || '';

    const key = generateProcessedLayoutKey(codeTagFamily, type, diseaseCode);

    if (typeof availableProcessedLayouts[key] != 'undefined') {
        return Object.values(availableProcessedLayouts[key]);
    }

    return [];
};

/**
 * Helper function to get the ProductTagLayout data that we are currently selecting
 *
 * @param state
 * @returns {boolean|*}
 */
export const getSelectedOfficialTagLayoutData = (state) => {
    const { userInput = {} } = state;
    const { selectedLayoutVariationID } = userInput;

    const availableLayouts = getAvailableProcessedLayouts(state);

    if (availableLayouts.length && selectedLayoutVariationID) {
        return availableLayouts.find(layout => layout.ID == selectedLayoutVariationID);
    }

    return false;
};

/**
 * Get the tag official type
 * @param store
 * @returns {string|null}
 */
export const getTagOfficialType = (state) => {
    const { tagType } = state.userInput || {};
    const product = getSelectedProduct(state);

    if (tagType === 'nlis') {
        switch (product.OfficialType) {
            case 'NAIT':
                return 'nait';
            case 'NLIS':
            default:
                return 'nlis';
        }
    }

    return null;
};

export const getAvailableSteps = (state) => {
    const { userInput, currentScreen } = state;
    const product = getSelectedProduct(state);

    // Prepare required steps
    let steps = [];

    const usageStep = {
        text: 'Usage',
        screen: 'UsageScreen',
        isActive: false,
        isCompleted: false,
    };
    const nlisPropertyStep = {
        text: 'Property',
        screen: 'NLISPropertyScreen',
        isActive: false,
        isCompleted: false,
    };
    const nlisAppearanceStep = {
        text: 'Appearance',
        screen: 'NlisAppearanceScreen',
        isActive: false,
        isCompleted: false,
    };
    const naitPropertyStep = {
        text: 'Property',
        screen: 'NAITPropertyScreen',
        isActive: false,
        isCompleted: false,
    };
    const naitAppearanceStep = {
        text: 'Appearance',
        screen: 'NAITAppearanceScreen',
        isActive: false,
        isCompleted: false,
    };
    const appearanceStep = {
        text: 'Appearance',
        screen: 'AppearanceScreen',
        isActive: false,
        isCompleted: false,
    };
    const reviewStep = {
        text: 'Review',
        screen: 'ReviewScreen',
        isActive: false,
        isCompleted: false,
    };

    // Add: Usage Step
    steps.push(usageStep);

    // Add: Conditional Step
    if (userInput) {
        const { tagType, TagShape } = userInput;

        if (tagType == 'nlis') {
            switch (product.OfficialType) {
                case 'NAIT':
                    // Add: NAIT Property Step
                    steps.push(naitPropertyStep);

                    // Add: NAIT Appearance Step
                    steps.push(naitAppearanceStep);
                    break;

                case 'NLIS':
                default:
                    // Add: NLIS Property Step
                    steps.push(nlisPropertyStep);

                    // Add: NLIS Appearance Step
                    steps.push(nlisAppearanceStep);
                    break;
            }
        } else {
            // Add: Appearance Step
            steps.push(appearanceStep);
        }
    }

    // Add: Review Step
    steps.push(reviewStep);

    // Mark which one is active and which one is completed
    steps.forEach((step, key) => {
        if (currentScreen == step.screen) {
            steps[key].isActive = true;
            steps[key].isCompleted = false;

            let tmpKey = key - 1;
            while (tmpKey >= 0) {
                steps[tmpKey].isActive = false;
                steps[tmpKey].isCompleted = true;
                tmpKey--;
            }
        }
    });

    return steps;
};

/**
 * Helper function to generate processed layout key
 *
 * @param productID
 * @param type
 * @param diseaseCode
 * @returns {string}
 */
export const generateProcessedLayoutKey = (
    productID = 0,
    type = '',
    diseaseCode = ''
) => {
    // Work around because we are treating all official as NLIS in terms of key
    if (type === 'nait') {
        type = 'nlis';
    }
    else if (type === 'nait-mmt') {
        type = 'mmt';
    }

    return `${productID}-${type}-${diseaseCode}`;
};

/**
 * Helper function to generate MMT processed layout key
 *
 * @param productID
 * @param type
 * @param diseaseCode
 * @returns {string}
 */
export const generateMMTProcessedLayoutKey = (tagWizardState, selectedProduct) => {
    const tagOfficialType = getTagOfficialType(tagWizardState);
    const codeTagFamily = selectedProduct.CodeTagFamily || '';
    const diseaseCode = '';
    const type = tagOfficialType === 'nait' ? 'nait-mmt' : 'mmt';
    const uniqueKey = generateProcessedLayoutKey(codeTagFamily, type, diseaseCode);

    return uniqueKey;
};

/**
 * Helper function to get finalised tag type for layout
 *
 * @param type
 * @returns {string}
 */
export const getFinalisedTagTypeLayout = (type) => {
    switch (type.toLowerCase()) {
        case 'editor':
            return 'CUSTOM';

        case 'mmt':
            return 'MMT';

        case 'nait-mmt':
            return 'NAIT-MMT';

        case 'nait':
            return 'NAIT';

        default:
            return 'NLIS';
    }
};

export const getAdditionalProductMappingForCustomTag = () => {
    // temporary mapping
    let mapping = {
        'Laser:custom': 'CL',
        'Laser:1 line': '1L',
        'Laser:2 lines': '2L',
        'Laser:3 lines': '3L',
        'Laser:custom:S': 'CLS',
        'Laser:1 line:S': '1LS',
        'Laser:2 lines:S': '2LS',
        'Laser:3 lines:S': '3LS',
        'Laser:1 line:E': '1LE',
        'Laser:2 lines:E': '2LE',
        'Laser:3 lines:E': '3LE',
        'Laser:1 line:SE': '1LSE',
        'Laser:2 lines:SE': '2LSE',
        'Laser:3 lines:SE': '3LSE',

        'Foil:custom': 'CF',
        'Foil:1 line': '1F',
        'Foil:2 lines': '2F',
        'Foil:3 lines': '3F',
        'Foil:1 line:S': '1FS',
        'Foil:2 lines:S': '2FS',
        'Foil:3 lines:S': '3FS',
    };

    return mapping;
};

export const getAdditionalProductMappingForNLIS = () => {

    let mapping = {
        'JLT:1:laser': 'OSL',
        'JLT:2:laser': 'TSL',
        'LT:1:laser': 'OSL',
        'LT:1:foil': 'OSF',
        'LT:2:laser': 'TSL',
        'LT:2:foil': 'TSF',
        'MT:1:laser': 'MTLS',
        'MT:1:foil': 'MTFS',
        'MTT:1:foil': 'MTFS',
    };

    return mapping;
};

export const getAdditionalLineItemProductsForOfficialTag = (store) => {
    const tagWizardState = store.tagWizard.present;
    const editorState = store.editor.present;
    const { revealBackSideBool = false, sides } = editorState;
    const { lineItemProducts, userInput } = tagWizardState;
    const { cartQty, printingMethod = '' } = userInput;
    const installationFeeSKU = 'CLSU'; // Temporary solution
    let list = [];

    if (lineItemProducts.length) {
        const lineItemProductsBySKU = getLineItemProductsBySKU(store);
        const productMapping = getAdditionalProductMappingForNLIS();
        const selectedProduct = getSelectedProduct(tagWizardState);
        const codeTagFamily = selectedProduct.CodeTagFamily || '';
        const totalSides = Object.values(sides).reduce((total, side) => {
            if (side.active) {
                total++;
            }

            return total;
        }, 0);

        const usedPrintingMethod = printingMethod != '' && printingMethod != null ? printingMethod : '';

        // Add all line items
        const sku = productMapping[`${codeTagFamily}:${totalSides}:${usedPrintingMethod.toLowerCase()}`];

        if (typeof lineItemProductsBySKU[sku] != 'undefined') {
            list.push({
                ...lineItemProductsBySKU[sku],
                quantity: cartQty || 1,
            });
        }

        // Only for CUSTOM add 1 installation fee
        // if(usedLineItemName == 'custom') {
        //     if(typeof(lineItemProductsBySKU[installationFeeSKU]) != 'undefined') {
        //         list.push({
        //             ...lineItemProductsBySKU[installationFeeSKU],
        //             quantity: 1
        //         });
        //     }
        // }
    }

    return list;
};
export const getAdditionalProductsForCustomTag = (store) => {
    const tagWizardState = store.tagWizard.present;
    const { lineItemProducts, userInput } = tagWizardState;
    const { cartQty, printingMethod = '' } = userInput;

    let list = [];

    if (lineItemProducts.length) {
        const lineItemProductsBySKU = getLineItemProductsBySKU(store);
        const usedLineItems = getUsedLineItems(store);
        const productMapping = getAdditionalProductMappingForCustomTag();
        const selectedProduct = getSelectedProduct(tagWizardState);
        const { MarkingLines, FoilMarkingLines } = selectedProduct;

        const usedPrintingMethod = printingMethod != '' && printingMethod != null ? printingMethod : '';

        // Add all line items
        usedLineItems.forEach((usedLineItemName) => {
            let mappingKey = `${usedPrintingMethod}:${usedLineItemName}`;
            const fallbackMappingKey = mappingKey;

            if (printingMethod == 'Laser' && usedLineItemName !== 'custom') {
                if (MarkingLines >= 4 && MarkingLines <= 6) {
                    mappingKey = `${mappingKey}:E`;
                }
                else if (MarkingLines >= 7 && MarkingLines <= 9) {
                    mappingKey = `${mappingKey}:S`;
                }
                else if (MarkingLines >= 10 && MarkingLines <= 12) {
                    mappingKey = `${mappingKey}:SE`;
                }
            }
            else if (printingMethod == 'Laser' && usedLineItemName === 'custom') {
                if (MarkingLines >= 7 && MarkingLines <= 16) {
                    mappingKey = `${mappingKey}:S`;
                }
            }
            else if (printingMethod == 'Foil' && usedLineItemName !== 'custom') {
                if (FoilMarkingLines >= 1 && FoilMarkingLines <= 3) {
                    mappingKey = `${mappingKey}:S`;
                }
            }

            console.log('mappingKey', mappingKey);

            const sku = productMapping[mappingKey];
            const fallbackSKU = fallbackMappingKey[mappingKey];

            if (typeof lineItemProductsBySKU[sku] != 'undefined') {
                list.push({
                    ...lineItemProductsBySKU[sku],
                    quantity: cartQty || 1,
                });
            }
            else if (typeof lineItemProductsBySKU[fallbackSKU] != 'undefined') {
                list.push({
                    ...lineItemProductsBySKU[fallbackSKU],
                    quantity: cartQty || 1,
                });
            }
        });
    }

    return list;
};

export const getIgnoreAbleLineItemIndices = (tagSummaryDataBaseEncoded) => {

    let ignoreAbleBuyableItems = [];
    if (tagSummaryDataBaseEncoded) {
        let tagSummaryDataJSONEncoded = window.decodeJsonFromBase64(tagSummaryDataBaseEncoded);
        if (tagSummaryDataJSONEncoded?.length) {
            let tagSummaryData = JSON.parse(tagSummaryDataJSONEncoded);
            let tagSummaryDataWithSidesMarking = tagSummaryData?.filter((elem) => {
                return elem.Title === 'Marking Front' || elem?.Title === 'Marking Back'
            })
            ignoreAbleBuyableItems = tagSummaryDataWithSidesMarking.reduce((acc, item, key) => {
                acc[key] = undefined;
                if (item.Value === '') {
                    acc[key] = true;
                };
                // if (item.Children !== undefined) {

                //     let somethingtoPrint = item.Children.filter((elem) => {
                //         return elem.Value != "";
                //     })
                //     if (!somethingtoPrint.length) {
                //         acc[key] = true;
                //     }

                // } else if (item.Value == 'Custom') {
                //     acc[key] = true;
                // }
                return acc;
            }, []);
        }
    }
    return ignoreAbleBuyableItems;
};

/**
 * Get MMT Payload for NLIS
 *
 * @param passedPayload
 * @param store
 * @param additionalData
 * @returns {[]}
 */
export const getMMTPayloadForNLISTag = (passedPayload, store, additionalData = {}) => {
    const editorState = store.editor.present;
    const tagWizardState = store.tagWizard.present;
    const { userInput, selectedMMT, lastSequenceNumber, selectedMMTTagLayout } = tagWizardState;
    const { PICNumber, StartingNumber, ContinueSequence, UsePrefix, Prefix, Suffix } = userInput;
    const { cartQty, IncludeMMT = 0, MMTProperty, MMTMarkingType } = userInput;
    const { markingCode = {}, svgs = {}, summary = '' } = additionalData;

    const tagData = getTagData(editorState, tagWizardState);

    let additionalProductsForMMT = [];

    if (IncludeMMT == 1) {

        // Setup payload
        let mmtPayload = {
            IsMMT: true,
            BuyableID: selectedMMT,
            TotalUnitItems: cartQty,

            // From NLIS
            PICNumber: PICNumber || '',
            StartingNumber: StartingNumber || '',
            ContinueSequence: ContinueSequence || '',
            UsePrefix: UsePrefix || '',
            Prefix: Prefix || '',
            Suffix: Suffix || '',
            LastSequenceNumber: lastSequenceNumber || '',

            // From MMT
            MMTProperty: MMTProperty || '',
            MMTMarkingType: MMTMarkingType || '',
            TagWizardData: '',
            TagEditorData: window.encodeJsonToBase64(JSON.stringify(selectedMMTTagLayout)),
            TagSummaryData: summary != '' ? window.encodeJsonToBase64(JSON.stringify(summary)) : '',

            SVGPreviewFront: typeof (svgs.front) != 'undefined' ? window.encodeJsonToBase64(svgs.front) : '',
            SVGPreviewBack: typeof (svgs.back) != 'undefined' ? window.encodeJsonToBase64(svgs.back) : '',
            MarkingCodeFront: typeof (markingCode.front) != 'undefined' ? markingCode.front : '',
            MarkingCodeBack: typeof (markingCode.back) != 'undefined' ? markingCode.back : '',

            PrintOption: getPrintOptionValue(tagData),
        };

        // Copy fields from parent
        const fieldsToBeCopied = [
            'SequenceStartingNumber',
            'IsCustomTag'
        ];

        fieldsToBeCopied.forEach(fieldKey => {
            if (typeof (passedPayload[fieldKey]) != 'undefined') {
                mmtPayload[fieldKey] = passedPayload[fieldKey];
            }
        });

        additionalProductsForMMT.push(mmtPayload);
    }

    return additionalProductsForMMT;
};

/**
 * Get MMT Payload for NAIT
 *
 * @param passedPayload
 * @param store
 * @param additionalData
 * @returns {Promise<[]>}
 */
export const getMMTPayloadForNAITTag = async (passedPayload, store, additionalData = {}) => {
    const editorState = store.editor.present;
    const tagWizardState = store.tagWizard.present;
    const { userInput } = tagWizardState;
    const {
        NAITNumber,
        UseParticipantCode,
        ParticipantCode,
        UseCustomList,
        NAITCustomList,
        StartingNumber,
        Year
    } = userInput;
    const { cartQty, IncludeMMT = 0 } = userInput;
    const {
        markingCode = {},
        svgs = {},
        summary = '',
        selectedBuyableID,
        selectedTagLayout,
    } = additionalData;
    const { IncludedProducts = [] } = selectedTagLayout;

    const tagData = getTagData(editorState, tagWizardState);

    let additionalProductsForMMT = [];

    if (IncludeMMT == 1) {

        // Setup payload
        let mmtPayload = {
            'IsNAIT-MMT': true,
            NAITGroupIdentifier: selectedTagLayout.NAITGroupIdentifier || '',
            BuyableID: selectedBuyableID,
            TotalUnitItems: cartQty,

            // From NAIT
            NAITNumber,
            UseParticipantCode,
            ParticipantCode,
            UseCustomList,
            NAITCustomList,
            StartingNumber,
            Year,

            // From MMT
            TagWizardData: '',
            TagEditorData:window.encodeJsonToBase64(JSON.stringify(selectedTagLayout)),
            TagSummaryData: summary != '' ? window.encodeJsonToBase64(JSON.stringify(summary)) : '',

            SVGPreviewFront: typeof (svgs.front) != 'undefined' ? window.encodeJsonToBase64(svgs.front) : '',
            SVGPreviewBack: typeof (svgs.back) != 'undefined' ? window.encodeJsonToBase64(svgs.back) : '',
            MarkingCodeFront: typeof (markingCode.front) != 'undefined' ? markingCode.front : '',
            MarkingCodeBack: typeof (markingCode.back) != 'undefined' ? markingCode.back : '',

            PrintOption: getPrintOptionValue(tagData),
        };

        // Copy fields from parent
        const fieldsToBeCopied = [
            'IsCustomTag'
        ];

        fieldsToBeCopied.forEach(fieldKey => {
            if (typeof (passedPayload[fieldKey]) != 'undefined') {
                mmtPayload[fieldKey] = passedPayload[fieldKey];
            }
        });

        console.log('debug NAIT-MMT payload', mmtPayload);

        additionalProductsForMMT.push(mmtPayload);
    }

    // Get the included products of the MMT
    if (IncludedProducts && IncludedProducts.length) {
        IncludedProducts.forEach(item => {
            additionalProductsForMMT.push({
                BuyableID: item.ID,
                TotalUnitItems: cartQty,
            })
        });
    }

    return additionalProductsForMMT;
};

/**
 * Helper function to get the SVG layout data from the given layout JSON data
 * Mostly used on MMT (NLIS & NAIT)
 *
 * @param selectedLayout
 * @param options
 * @param dispatch
 * @param getState
 * @returns {Promise<void>}
 */
export const getSVGLayoutDataFromJSON = async (selectedLayout, options = {}, { dispatch, getState }) => {
    let state = getState();
    let response = {};

    const { TagColour = null, FontColourCode = null } = options || {};
    const currentTagColour = state.editor.present.activeColour;
    const currentTextColour = state.editor.present.textColour;

    // Store current editor data so we can revert
    const currentEditorData = getEditorExportedJSONData(state);

    // Now set the current canvas to the given layout
    let decodedJSONData = window.decodeJsonFromBase64(selectedLayout.EncodedJSONData);
    if (typeof (decodedJSONData) == 'string') {
        decodedJSONData = JSON.parse(decodedJSONData);
    }

    await Promise.all([
        dispatch(resetCanvases()),
        dispatch(setTagData(decodedJSONData))
    ]).then(() => {
        return Promise.all([dispatch(setupCanvases())]);
    }).then(async () => {
        state = getState();

        // Change colour temporarily
        if (TagColour && FontColourCode) {
            await dispatch(changeFontColour(TagColour, FontColourCode));
        }

        const mmtSvgs = await exportSVGs(state.editor.present);
        const mmtMarkingCode = getMarkingCode(getState());

        response.svgs = mmtSvgs;
        response.markingCode = mmtMarkingCode;
    }).finally(async () => {
        // reset
        await dispatch(resetCanvases());
        await dispatch(setTagData(currentEditorData));
        await dispatch(setupCanvases());

        // Revert colour
        if (TagColour && FontColourCode) {
            await dispatch(changeFontColour(currentTagColour, currentTextColour));
        }
    });

    return response;
};

export const getLineItemProductsBySKU = (store) => {
    const tagWizardState = store.tagWizard.present;
    const { lineItemProducts, products } = tagWizardState;

    let list = {};

    lineItemProducts.forEach((id) => {
        if (typeof products[id] != 'undefined') {
            const { InternalItemID } = products[id];

            list[InternalItemID] = products[id];
        }
    });

    return list;
};

export const getUsedLineItems = (store) => {

    const editorState = store.editor.present;
    console.log(editorState);
    const { regions, styles, revealBackSideBool, sides } = editorState;

    let usedLineItems = [];
    let activeStyles = [];

    if (regions && styles) {
        Object.values(regions).forEach(region => {
            const { activeStyle, side } = region;

            if (sides[side] != undefined && sides[side].active) {
                activeStyles.push(activeStyle);
            }
        });

        if (activeStyles.length) {
            activeStyles.forEach((activeStyle) => {
                if (typeof styles[activeStyle] != 'undefined') {
                    const { name } = styles[activeStyle];

                    if (name) {
                        usedLineItems.push(name.toLowerCase());
                    }
                }
            });
        }
    }
    return usedLineItems;
};

export const getAvailableMMTs = (state) => {
    const { matchingManagementTags } = state;
    const selectedProduct = getSelectedProduct(state);
    const productMMTList = selectedProduct.MatchingManagementTags;

    if (selectedProduct && productMMTList.length > 0) {
        const availableTags = Object.values(matchingManagementTags).reduce((list, mmtProduct) => {
            const { ID, CodeTagFamily } = mmtProduct;
            const status = productMMTList.some(el => el.CodeTagFamily == CodeTagFamily);
            if (status) {
                list[ID] = mmtProduct;

            }

            return list;
        }, {});

        return Object.values(availableTags);
    }

    return [];
};

export const getSelectedMMTsAvailableColours = (selectedMMT, mmtProductList = []) => {
    if (mmtProductList.length == 0 || !selectedMMT) {
        return [];
    }

    const { CodeTagFamily } = selectedMMT;

    const sameTagFamilyList = mmtProductList.reduce((list, item) => {
        if (item.CodeTagFamily == CodeTagFamily) {
            list.push(item);
        }

        return list;
    }, []);


    return buildColourDropdown(sameTagFamilyList, 'mmt');
};

export const getSelectedMMTFsAvailableColours = (selectedMMTF, mmtProductList = []) => {
    if (mmtProductList.length == 0 || !selectedMMTF) {
        return [];
    }

    const { CodeTagFamily } = selectedMMTF;

    const sameTagFamilyList = mmtProductList.reduce((list, item) => {
        if (item.CodeTagFamily == CodeTagFamily) {
            list.push(item);
        }

        return list;
    }, []);


    return buildColourDropdown(sameTagFamilyList, 'mmt');
};

export const buildReviewItem = (key = '', value = '', children = []) => {
    let obj = {
        Title: key,
        Value: value,
    };

    if (children && children.length) {
        obj.Children = children;
    }

    return obj;
};

export const getDisplayedReviewsForMMT = (tagWizard = {}, editor = {}) => {
    if (!tagWizard || !editor) {
        return [];
    }

    const { lastSequenceNumber = '', userInput = {} } = tagWizard;
    const {
        StartingNumber = '',
        ContinueSequence,
        PICNumber,
        UsePrefix,
        Prefix,
        cartQty,
        MMTMarkingType,
        MMTProperty
    } = userInput;

    const startNum = ContinueSequence !== undefined && parseInt(ContinueSequence) === 1 ? lastSequenceNumber || '' : StartingNumber || '';

    // Cart qty has to be minus 1 so it matches the correct sequence.
    // If you buy 1 item and sequence starts at 033, the output should be 033, not 033 & 034.
    const endNum = zeroPad(parseInt(startNum) + (cartQty - 1), startNum.length);

    if (typeof (userInput.IncludeMMT) == 'undefined' || userInput.IncludeMMT != 1) {
        return '';
    }

    let list = [];

    if (MMTMarkingType) {
        if (MMTMarkingType != '' && MMTMarkingType !== '') {
            list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW_MMT.MARKING_TYPE'), MMTMarkingType));
        }

        if (MMTMarkingType == 'Property Name/Sequence Number' && MMTProperty !== '') {
            list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW_MMT.PROPERTY_NAME'), MMTProperty));
        }

        if (MMTMarkingType == 'PIC/Sequence Number' && PICNumber !== '') {
            list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW_MMT.PIC_NUMBER'), PICNumber));
        }
    }

    if (typeof UsePrefix != 'undefined' && parseInt(UsePrefix) === 1 && typeof Prefix != 'undefined' && Prefix !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW_MMT.PREFIX'), Prefix));
    }

    if (startNum && startNum !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW_MMT.SEQUENCE_NUMBERS'), startNum == endNum ? startNum : `${startNum} - ${endNum}`));
    }

    return list;
};

export const getDisplayedReviews = (tagWizard = {}, editor = {}) => {
    if (!tagWizard || !editor) {
        return [];
    }

    const { userInput = {} } = tagWizard;
    const { tagType = '', printingMethod = '' } = userInput;
    const officialType = getTagOfficialType(tagWizard);

    let list = [];

    // NLIS - Review basic
    if (tagType && tagType === 'nlis') {
        switch (officialType) {
            case 'nlis':
                list = list.concat(getDisplayedReviewsForNLISBasic(tagWizard));
                break;

            case 'nait':
                list = list.concat(getDisplayedReviewsForNAITBasic(tagWizard));
                break;
        }
    }

    // NLIS & Custom - Printing Method
    if (printingMethod && printingMethod !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.MARKING_METHOD'), printingMethod));
    }

    // NLIS - Layer List
    if (tagType && tagType === 'nlis') {
        list = list.concat(getDisplayedReviewsForNLISLayers(editor));
    }

    // Custom - Layer List
    if (tagType && tagType !== 'nlis') {
        let reviewListForCustomLayer = getDisplayedReviewsForCustomLayers(editor);
        reviewListForCustomLayer.forEach(obj => {

            if (obj.Children && obj.Children.every(child => !child.Children && !child.Value)) {
                obj.Value = "";
            } else if (obj.Children == undefined && obj.Value == "Custom") {
                obj.Value = "";
            }

        })
        list = list.concat(reviewListForCustomLayer);
    }

    return list;
};

export const getDisplayedReviewsForNLISBasic = (tagWizard = {}) => {

    const product = getSelectedProduct(tagWizard) || {};
    const YearCode = window.yearCode || 'S';

    const { userInput = {} } = tagWizard;

    const {
        PICVerified,
        lastSequenceNumber = '',
        propertyState,
    } = tagWizard;

    const {
        BuyableContinueSequence = false,
        PostBreederLetter = false,
    } = product;

    const {
        DiseaseCode,
        DAFAuthorisationCheckbox,
        DAFAuthorisationNumber,
        CertificateNumber,
        CertificateQuantity,
        CertificateIssueDate,
        DAFAuthorisationIssueDate,
        StartingNumber = '',
        ContinueSequence,
        PICNumber,
        OwnerName,
        BusinessName,
        FirstName,
        LastName,
        PropertyName,
        UsePrefix,
        Prefix,
        UseBrandOverPIC,
        Brand,
        LazyLetter = '',
        cartQty,
        printingMethod,
        useBrandPic,
    } = userInput;
    const startNum = ContinueSequence !== undefined && parseInt(ContinueSequence) === 1 ? lastSequenceNumber : StartingNumber;
    const endNum = zeroPad(parseInt(startNum) + (cartQty - 1), startNum ? startNum.length : 0);

    let list = [];

    if (PICVerified !== undefined && PICVerified === false) {
        list.push(buildReviewItem('', getTranslation('TAG_WIZARD.TAG_REVIEW.PIC_NOT_VERIFIED')));
    }

    if (PICNumber && PICNumber !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.PIC_NUMBER'), PICNumber));
    }

    if (FirstName && FirstName !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.FIRST_NAME'), FirstName));
    }

    if (LastName && LastName !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.LAST_NAME'), LastName));
    }

    if (BusinessName && BusinessName !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.BUSINESS_NAME'), BusinessName));
    }

    if (PropertyName && PropertyName !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.PROPERTY_NAME'), PropertyName));
    }

    if (OwnerName && OwnerName !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.OWNER_NAME'), OwnerName));
    }

    if (PostBreederLetter && PostBreederLetter !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.BREEDER_POST_CODE'), PostBreederLetter));
    }

    if (YearCode && YearCode !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.YEAR_CODE'), YearCode));
    }

    if (typeof (UsePrefix) != 'undefined' && parseInt(UsePrefix) === 1 && typeof (Prefix) != 'undefined' && Prefix !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.PREFIX'), Prefix));
    }

    if (BuyableContinueSequence === true) {
        if (startNum && startNum !== '') {
            list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.SEQUENCE_NUMBERS'), startNum == endNum ? startNum : `${startNum} - ${endNum}`));
        }
    }

    if (DiseaseCode && DiseaseCode !== false && DiseaseCode !== 'None') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.DISEASE_CODE'), DiseaseCode));
    }

    list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.LOGO'), 'NLIS'));

    if (propertyState && propertyState !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.STATE'), propertyState));
    }
    if (cartQty > 3500 && CertificateNumber && CertificateNumber !== '' && propertyState == 'NSW') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.CERTIFICATE_NUMBER'), CertificateNumber));
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.CERTIFICATE_QUANTITY'), CertificateQuantity));
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.CERTIFICATE_ISSUE_DATE'), CertificateIssueDate));
    }
    // if (cartQty < 3500){
    //     list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.CERTIFICATE_NUMBER'), ''));
    //     list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.CERTIFICATE_QUANTITY'), ''));
    //     list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.CERTIFICATE_ISSUE_DATE'), ''));
    // }
    if (propertyState == 'QLD' && (DAFAuthorisationCheckbox !== undefined && DAFAuthorisationCheckbox === false) || DAFAuthorisationCheckbox !== undefined) {
        if (DAFAuthorisationCheckbox === 0) {
            if (DAFAuthorisationIssueDate && DAFAuthorisationIssueDate !== '') {
                list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.DAF_AUTHORISATION_ISSUE_DATE'), DAFAuthorisationIssueDate));
            }

            if (DAFAuthorisationNumber && DAFAuthorisationNumber !== '') {
                list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.DAF_AUTHORISATION_NUMBER'), DAFAuthorisationNumber));
            }
        }
        else {
            list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.DAF_AUTHORISATION'), 'Requested'));
        }
    }

    if (product.Brand && printingMethod === 'Foil' && Brand !== undefined && Brand != '' && UseBrandOverPIC !== undefined && UseBrandOverPIC) {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.USE_BRAND_OVER_PIC'), Brand));
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.LAZY_LETTER'), getTranslation(`FIELD.LAZY_LETTER.OPTIONS.${LazyLetter}`)));
    }

    if (printingMethod === 'Laser'  && LazyLetter != '' && (UseBrandOverPIC || useBrandPic)) {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.USE_BRAND_OVER_PIC'), Brand));
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.LAZY_LETTER'), getTranslation(`FIELD.LAZY_LETTER.OPTIONS.${LazyLetter}`)));
    }

    return list;
};

export const getDisplayedReviewsForNAITBasic = (tagWizard = {}) => {

    const product = getSelectedProduct(tagWizard) || {};
    const tagLayout = getSelectedOfficialTagLayoutData(tagWizard) || {};

    const { userInput = {} } = tagWizard;
    const { NAITVariationType = '' } = tagLayout;

    const {
        PICVerified,
    } = tagWizard;

    const {
        UseDuplicate,
        UseParticipantCode,
        NAITNumber,
        OwnerName,
        FirstName,
        LastName,
        PropertyName,
        ParticipantCode,
        UseCustomList,
        NAITCustomList,
        StartingNumber,
        tagProductionType,
        Year,
    } = userInput;

    let list = [];

    if (PICVerified !== undefined && PICVerified === false) {
        list.push(buildReviewItem('', getTranslation('TAG_WIZARD.TAG_REVIEW.PIC_NOT_VERIFIED')));
    }

    if (NAITNumber && NAITNumber !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.NAIT_NUMBER'), NAITNumber));
    }

    if (FirstName && FirstName !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.FIRST_NAME'), FirstName));
    }

    if (LastName && LastName !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.LAST_NAME'), LastName));
    }

    if (PropertyName && PropertyName !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.PROPERTY_NAME'), PropertyName));
    }

    if (OwnerName && OwnerName !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.OWNER_NAME'), OwnerName));
    }

    if (UseDuplicate && UseDuplicate == 1) {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.USE_DUPLICATE'), 'Yes'));
    }

    if (UseParticipantCode && ParticipantCode && ParticipantCode !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.PARTICIPANT_CODE'), ParticipantCode));
    }

    if (NAITVariationType.indexOf('YR') > -1 && Year && Year !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.YEAR'), Year));
    }

    if (UseCustomList == 1) {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.CUSTOM_LIST'), NAITCustomList.map(item => item.text).join(', ')));
    } else {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.STARTING_NUMBER'), StartingNumber));
    }

    if (product.IsCattle && tagProductionType && tagProductionType !== '') {
        list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.TAG_PRODUCTION_TYPE'), tagProductionType));
    }

    list.push(buildReviewItem(getTranslation('TAG_WIZARD.TAG_REVIEW.LOGO'), 'NAIT'));

    return list;
};

export const getDisplayedReviewsForCustomLayers = (editor = {}) => {
    // const { revealBackSideBool = false } = editor.tagData;
    const sides = editor && editor.tagData && editor.tagData.sides ? editor.tagData.sides : '';

    let list = [];

    if (Object.values(sides).length == 0) {
        return [];
    }

    Object.values(sides).map((side, index) => {
        if (side.active && side.regions) {
            Object.values(side.regions).map((region, index) => {
                if (region.active && region.styles) {
                    Object.values(region.styles).map((style, index) => {
                        if (region.activeStyle === style.id) {
                            // if(!(side.id == 'back' && !revealBackSideBool)) {

                            let children = [];

                            Object.values(style.layers).map((layer, index) => {
                                const { activeType, previewTextReview } = layer;
                                children.push(buildReviewItem(capitalize(activeType), previewTextReview));
                            });

                            list.push(buildReviewItem(`Marking ${side.name}`, style.name, children));

                            // }
                        }
                    });
                }
            });
        }
    });

    return list;
};

export const getDisplayedReviewsForNLISLayers = (editor = {}) => {

    const capitalize = (s) => {
        if (typeof s !== 'string') return '';
        return s.charAt(0).toUpperCase() + s.slice(1);
    };

    const { revealBackSideBool = false } = editor.tagData;
    const sides = editor && editor.tagData && editor.tagData.sides ? editor.tagData.sides : '';

    let list = [];

    if (Object.values(sides).length == 0) {
        return [];
    }

    Object.values(sides).map((side, index) => {
        if (side.active && side.regions) {
            Object.values(side.regions).map((region, index) => {
                if (region.active && region.styles) {
                    Object.values(region.styles).map((style, index) => {
                        if (region.activeStyle === style.id) {
                            // if(!(side.id == 'back' && !revealBackSideBool)) {

                            let children = [];

                            Object.values(getNLISCustomLayers(style.layers)).map((layer, index) => {
                                const { activeType, previewTextReview } = layer;
                                children.push(buildReviewItem(capitalize(activeType), previewTextReview));
                            });

                            if (children.length > 0) {
                                list.push(buildReviewItem(`Marking Side`, side.name, children));
                            }
                            // }
                        }
                    });
                }
            });
        }
    });

    return list;
};
/**
 * Calculate the nearest cart qty depending on the params
 *
 * @param usePack
 * @param cartQty
 * @param packSize
 * @param minimumOrderQuantity
 * @returns {number}
 */
export const calculateNearestCartQty = (usePack = false, cartQty = 0, packSize = 1, minimumOrderQuantity = 0) => {
    const finalPackSize = packSize > 0 ? packSize : 1;

    if (cartQty <= minimumOrderQuantity) return minimumOrderQuantity;

    if (usePack === true && cartQty % finalPackSize != 0) {
        return Math.ceil(cartQty / finalPackSize) * finalPackSize;
    }

    return cartQty;
};

export const getMarkingCode = (state) => {
    const tagWizardPresent = state.tagWizard.present;
    const editorPresent = state.editor.present;
    const { userInput = {} } = tagWizardPresent;
    const { tagType = '' } = userInput;
    let markingCode = {
        front: '',
        back: '',
    };

    if (tagType == 'nlis') {
        const tagData = getTagDataForEditor(getTagData(editorPresent, tagWizardPresent), editorPresent, tagWizardPresent);
        let sides = JSON.parse(JSON.stringify(tagData.tagData.sides));

        Object.entries(sides).forEach(([sideID, side]) => {
            let currentSideKey = sideID;
            let markingType = '';

            Object.entries(side.regions).forEach(([regionID, region]) => {
                const { styles, activeStyle } = region;

                if (typeof (styles[activeStyle]) != 'undefined') {
                    markingType = 'O';
                }

            });

            markingCode[currentSideKey] = markingType;
        });
    }
    else if (tagType == 'editor') {
        const tagData = getTagDataForEditor(getTagData(editorPresent, tagWizardPresent), editorPresent, tagWizardPresent);
        let sides = JSON.parse(JSON.stringify(tagData.tagData.sides));

        Object.entries(sides).forEach(([sideID, side]) => {
            let currentSideKey = sideID;
            let markingType = '';

            Object.entries(side.regions).forEach(([regionID, region]) => {
                const { styles, activeStyle } = region;

                if (typeof (styles[activeStyle]) != 'undefined') {
                    const currentActiveStyle = styles[activeStyle];

                    switch (currentActiveStyle.name.toLowerCase()) {
                        case '1 line':
                            markingType = '1L';
                            break;
                        case '2 lines': case '2 line':
                            markingType = '2L';
                            break;
                        case '3 lines': case '3 line':
                            markingType = '3L';
                            break;
                        case 'custom':
                            markingType = 'C';
                            break;
                    }

                    // BUT! Let's check if there is RFID in this
                    const hasRFID = Object.entries(currentActiveStyle.layers).some((layerID, layer) => layer.activeType == 'rfid');
                    if (hasRFID) {
                        markingType = window.yearCode || 'S';
                    }
                }

            });

            markingCode[currentSideKey] = markingType;
        });
    }

    return markingCode;
};

export const isVisualTagCategory = () => {
    if (window.categories !== undefined && Array.isArray(window.categories) && window.categories.length > 0) {
        if (window.categories.includes('Visual Identification')) {
            return true;
        }
    }

    return false;
};

/**
 * Get the total layers of a side based on the given side (has to be tagData converted)
 *
 * @param side
 * @returns {number}
 */
export const getSideTotalLayers = (side) => {
    let total = 0;

    if (side.active) {
        Object.values(side.regions).forEach(region => {
            const { active: regionActive, activeStyle } = region;
            if (regionActive) {
                Object.values(region.styles).forEach(style => {
                    if (activeStyle === style.id) {
                        Object.values(style.layers).forEach(layer => {
                            const { activeType } = layer;

                            if (activeType.toLowerCase() != 'rfid') {
                                total++;
                            }
                        });
                    }
                });
            }
        });
    }

    return total;
};

/**
 * Get the PrintOption value (for PAUL)
 *
 * @param tagData
 * @returns {number}
 */
export const getPrintOptionValue = (tagData) => {
    let value = 0;
    const { sides } = tagData.tagData;

    // Unfortunately we have to hardcode this.
    let frontTotalLayers = 0;
    let backTotalLayers = 0;

    if (sides.front !== undefined) {
        frontTotalLayers = getSideTotalLayers(sides.front);
    }
    if (sides.back !== undefined) {
        backTotalLayers = getSideTotalLayers(sides.back);
    }

    // Decide
    if (frontTotalLayers > 0 && backTotalLayers > 0) {
        // Front & Back
        value = 3;
    }
    else if (backTotalLayers > 0) {
        // Back ONLY
        value = 2;
    }
    else if (frontTotalLayers > 0) {
        // Front ONLY
        value = 1;
    }

    return value;
};

/**
 * Get the payload for Official Tag Cart Item
 *
 * @param passedPayload
 * @param dispatch
 * @param getState
 * @returns {Promise<{TagWizardData: *, MarkingCodeBack: *, PrintOption: *, RelatedBuyables: *, TagEditorData: *, SVGPreviewBack: (*|string), SVGPreviewFront: (*|string), IsCustomTag: boolean, MarkingCodeFront: *}>}
 */
export const getPayloadForOfficalTagCartItem = async (passedPayload, { dispatch, getState }) => {
    let state = getState();

    const tagWizardState = state.tagWizard.present;
    const editorState = state.editor.present;

    // Get the current MAIN tag data, marking code & svgs
    const tagData = getTagData(editorState, tagWizardState);
    const markingCode = getMarkingCode(state);
    const svgs = exportSVGs(editorState);

    // Get the related buyables (this is where MMT, Male Buttons reside)
    const relatedBuyables = await getAdditionalPayloadBuyablesForOffical(passedPayload, { dispatch, getState });

    // Combine them with the previously passed Payload
    const payload = {
        ...passedPayload,
        IsCustomTag: true,
        TagWizardData: window.encodeJsonToBase64(JSON.stringify(getTagWizardExportedJSONData(tagWizardState))),
        TagEditorData: window.encodeJsonToBase64(JSON.stringify(getEditorExportedJSONData(state))),
        RelatedBuyables: window.encodeJsonToBase64(JSON.stringify(relatedBuyables)),
        SVGPreviewFront: typeof (svgs.front) != 'undefined' ?  window.encodeJsonToBase64(svgs.front) : '',
        SVGPreviewBack: typeof (svgs.back) != 'undefined' ?  window.encodeJsonToBase64(svgs.back) : '',
        MarkingCodeFront: markingCode.front,
        MarkingCodeBack: markingCode.back,
        PrintOption: getPrintOptionValue(tagData),
    };

    // And check if have anything specific
    const extraPayload = getExtraPayloadBuyablesForOffical({ dispatch, getState });

    return {
        ...payload,
        ...extraPayload,
    };
};

/**
 * Get all the extras payload when adding / updating Official Tag Type
 *
 * @param passedPayload
 * @param dispatch
 * @param getState
 * @returns {Promise<*[]|Array>}
 */
export const getExtraPayloadBuyablesForOffical = ({ dispatch, getState }) => {
    const officialType = getTagOfficialType(getState().tagWizard.present);

    switch (officialType) {
        case 'nlis':
            return getExtraPayloadBuyablesForNLIS({ dispatch, getState });

        case 'nait':
            return getExtraPayloadBuyablesForNAIT({ dispatch, getState });

        default:
            return {};
    }
};

/**
 * Get all the extras payload when adding / updating NAIT
 *
 * @param passedPayload
 * @param dispatch
 * @param getState
 * @returns {Promise<*[]|Array>}
 */
export const getExtraPayloadBuyablesForNLIS = ({ getState }) => {
    const { userInput } = getState().tagWizard.present;
    const {
        ContinueSequence = 0,
    } = userInput;

    return {
        ContinueSequence: ContinueSequence == 1,
    }
};

/**
 * Get all the extras payload when adding / updating NAIT
 *
 * @param passedPayload
 * @param dispatch
 * @param getState
 * @returns {Promise<*[]|Array>}
 */
export const getExtraPayloadBuyablesForNAIT = ({ getState }) => {
    const { userInput } = getState().tagWizard.present;
    const {
        NAITNumber,
        StartingNumber,
        UseParticipantCode = 0,
        ParticipantCode = '',
        IsDuplicate = 0,
        Year = '',
        UseCustomList = 0,
        NAITCustomList = [],
    } = userInput;

    const validationParams = buildValidateNAITSequenceParams(getState());

    return {
        PICNumber: NAITNumber,
        ContinueSequence: false,
        SequenceStartingNumber: UseCustomList != 1 ? StartingNumber : null,
        DuplicateTag: Boolean(IsDuplicate),
        ParticipantCode: UseParticipantCode == 1 ? ParticipantCode : null,
        TagYear: Year,
        VariationType: validationParams.VariationType || '',
        SequenceList: UseCustomList == 1 ? NAITCustomList.map(item => item.text).join(',') : null,
    }
};

/**
 * Get all the required buyables when adding / updating Official Tag Type
 *
 * @param passedPayload
 * @param dispatch
 * @param getState
 * @returns {Promise<*[]|Array>}
 */
export const getAdditionalPayloadBuyablesForOffical = async (passedPayload, { dispatch, getState }) => {
    const officialType = getTagOfficialType(getState().tagWizard.present);

    switch (officialType) {
        case 'nlis':
            return await getAdditionalPayloadBuyablesForNLIS(passedPayload, { dispatch, getState });

        case 'nait':
            return await getAdditionalPayloadBuyablesForNAIT(passedPayload, { dispatch, getState });

        default:
            return [];
    }
};

/**
 * Get all the required buyables when adding / updating NLIS
 *
 * @param passedPayload
 * @param dispatch
 * @param getState
 * @returns {Promise<*[]>}
 */
export const getAdditionalPayloadBuyablesForNLIS = async (passedPayload, { dispatch, getState }) => {
    let state = getState();
    const tagWizardState = state.tagWizard.present;
    const { userInput, selectedMMTTagLayout = null } = tagWizardState;
    const { IncludeMMT = 0 } = userInput;

    // MMT
    // -----------------------
    let additionalProductsForMMT = [];
    let mmtAdditionalData = {
        summary: getDisplayedReviewsForMMT(state.tagWizard.present, state.editor.present),
    };

    const mmtProduct = getSelectedMMT(tagWizardState);
    const mmtLayoutOptions = {
        TagColour: mmtProduct.TagColour,
        FontColourCode: mmtProduct.FontColourCode,
    };

    if (IncludeMMT == 1 && selectedMMTTagLayout != null) {
        mmtAdditionalData = {
            ...mmtAdditionalData,
            ...await getSVGLayoutDataFromJSON(selectedMMTTagLayout, mmtLayoutOptions, { dispatch, getState }),
        };

        additionalProductsForMMT = await getMMTPayloadForNLISTag(passedPayload, state, mmtAdditionalData);
    }

    // Selected Male Buttons
    // -----------------------
    const selectedMaleButtonProducts = getSelectedMaleButtonProducts(tagWizardState).map(product => {
        return {
            BuyableID: product.ID,
            TotalUnitItems: product.quantity,
        };
    });

    // Additional Line Item Products for Official Tag
    // -----------------------
    const additionalProductsForNLIS = getAdditionalLineItemProductsForOfficialTag(state).map((product) => {
        return {
            BuyableID: product.ID,
            TotalUnitItems: product.quantity,
        };
    });

    // Combined Buyables
    const relatedBuyables = [...additionalProductsForNLIS, ...additionalProductsForMMT, ...selectedMaleButtonProducts];

    return relatedBuyables;
};

/**
 * Get all the required buyables when adding / updating NAIT
 *
 * @param passedPayload
 * @param dispatch
 * @param getState
 * @returns {Promise<*[]>}
 */
export const getAdditionalPayloadBuyablesForNAIT = async (passedPayload, { dispatch, getState }) => {
    let state = getState();
    const tagWizardState = state.tagWizard.present;
    const { userInput, selectedMMT, selectedMMTTagLayout = null, selectedMMTF, selectedMMTFTagLayout = null } = tagWizardState;
    const { IncludeMMT = 0 } = userInput;

    // MMT & MMTF
    // -----------------------
    let additionalProductsForMMT = [],
        additionalProductsForMMTF = [];
    let mmtAdditionalData = {
        summary: getDisplayedReviewsForMMT(state.tagWizard.present, state.editor.present),
    };
    let mmtfAdditionalData = {
        summary: getDisplayedReviewsForMMT(state.tagWizard.present, state.editor.present),
    };

    if (IncludeMMT == 1) {
        // Male Tag
        // ----------------------
        if (selectedMMTTagLayout != null) {
            const mmtProduct = getSelectedMMT(tagWizardState);
            const mmtLayoutOptions = {
                TagColour: mmtProduct.TagColour,
                FontColourCode: mmtProduct.FontColourCode,
            };

            mmtAdditionalData = {
                selectedBuyableID: selectedMMT,
                selectedTagLayout: selectedMMTTagLayout,
                ...mmtAdditionalData,
                ...await getSVGLayoutDataFromJSON(selectedMMTTagLayout, mmtLayoutOptions, { dispatch, getState }),
            };

            additionalProductsForMMT = await getMMTPayloadForNAITTag(passedPayload, state, mmtAdditionalData);
        }

        // Female Tag
        // ----------------------
        if (selectedMMTFTagLayout != null) {
            const mmtfProduct = getSelectedMMTF(tagWizardState);
            const mmtfLayoutOptions = {
                TagColour: mmtfProduct.TagColour,
                FontColourCode: mmtfProduct.FontColourCode,
            };

            mmtfAdditionalData = {
                selectedBuyableID: selectedMMTF,
                selectedTagLayout: selectedMMTFTagLayout,
                ...mmtfAdditionalData,
                ...await getSVGLayoutDataFromJSON(selectedMMTFTagLayout, mmtfLayoutOptions, { dispatch, getState }),
            };

            additionalProductsForMMTF = await getMMTPayloadForNAITTag(passedPayload, state, mmtfAdditionalData);
        }
    }

    // Included Items (ONLY NAIT DOES THIS, NLIS DOESNT)
    // -----------------------
    const includedItemsProducts = getSelectedIncludedItemsPayloadForNAIT(tagWizardState).map(product => {
        return {
            IsNAITIncludedItem: true,
            BuyableID: product.ID,
            TotalUnitItems: product.quantity,
            SalePrice: product.SalePrice // TODO: Check this, hopefully this works
        };
    });

    // Selected Male Buttons
    // -----------------------
    const selectedMaleButtonProducts = getSelectedMaleButtonProducts(tagWizardState).map(product => {
        return {
            BuyableID: product.ID,
            TotalUnitItems: product.quantity,
        };
    });

    // Additional Line Item Products for Official Tag
    // -----------------------
    const additionalProductsForOfficialTag = getAdditionalLineItemProductsForOfficialTag(state).map((product) => {
        return {
            BuyableID: product.ID,
            TotalUnitItems: product.quantity,
        };
    });

    // Combined Buyables
    const relatedBuyables = [...includedItemsProducts, ...additionalProductsForOfficialTag, ...additionalProductsForMMT, ...additionalProductsForMMTF, ...selectedMaleButtonProducts];

    return relatedBuyables;
};

/**
 * Get the possible Variation Type String for NAIT tag
 * @param store
 * @returns {[]}
 */
export const getPossibleVariationTypesForNAIT = (store) => {
    const tagWizardState = store.tagWizard.present;
    const product = getSelectedProduct(tagWizardState);
    const {
        UseDuplicate = 0,
        UseParticipantCode = 0,
        Year,
        tagProductionType,
    } = tagWizardState.userInput;

    const finalUseParticipantCode = tagProductionType == 'Dairy' ? UseParticipantCode : 0;
    const finalYear = Year;

    let list = [];

    if (product?.Replacement) {

        // For Replacement Tag
        //----------------
        if (finalUseParticipantCode == 1) {
            list.push('PATCODE-RFID');
        } else {
            list.push('NAITNUM-RFID');
        }

    }
    else {

        // For Birth Tag
        //----------------
        if (finalUseParticipantCode == 1) {

            if (finalYear) {
                list.push('PATCODE-YR-SERIES');
            }

        } else {

            list.push('NAITNUM-SERIES');

            if (finalYear) {
                list.push('NAITNUM-YR-SERIES');
            }

        }
    }

    return list;
};